import React from 'react'
import { cn } from '@/utilities/ui'

import type { EmbedMeta, EmbedVideoProps } from './types'
import { embedMappings } from './embedMappings'

export type { EmbedVideoProps } from './types'

const defaultMeta: EmbedMeta = {
    buildSource: () => ({
        srcDoc: `<html></html>`, // Default to a blank document
    }),
    iframeProps: {},
}

export const EmbedVideoBlock: React.FC<EmbedVideoProps> = (props) => {
    const { videoId, type, className } = props
    const { buildSource, iframeProps } = embedMappings[type] || defaultMeta
    const source = buildSource(props)
    return (
        <div className='flex justify-center items-center'>
            <iframe
                {...iframeProps}
                data-src={`https://qz.com/embed/inset/iframe?id=${type}-video-${videoId}&start=0`}
                src={'src' in source ? source.src : undefined}
                srcDoc={'srcDoc' in source ? source.srcDoc.trim().replaceAll(/\s+/g, ' ') : undefined}
                id={`${type}-${videoId}`}
                data-chomp-id={videoId}
                data-recommended='false'
                data-recommended-id={`${type}://${videoId}`}
                className={cn('my-2', { 'w-full': !iframeProps.width }, iframeProps.className, className)}
                frameBorder='0'
                scrolling='no'
                loading='lazy'
                allowFullScreen
                sandbox='allow-scripts allow-same-origin'
            ></iframe>
        </div>
    )
}
